import { useEffect, useState } from 'react';
import { Box, TableBody } from '@mui/material';
import axios from 'axios';
import { AddButton } from '../../../components/common/button/CustomButtons';
import ChildHeader from '../../../components/ui/ChildHeader';
import { PersitedDatePicker, TableCustom } from '../../../components/common';
import { useQuery } from '../../../hooks/UseQuery';
import useConfirm from '../../../components/common/useConfirm';
import { useNavigate } from 'react-router-dom';
import formatDate from '../../../components/common/formatDate';
import {
  DeleteIconButton,
  EditIconButton,
  ViewIconButton,
} from '../../../components/common/button/CustomIconButton';
import { constants } from './constant';
import ModalCustom from '../../../components/common/Modal';
import SelectSupplier from './components/SelectSupplier';
import {
  style1,
  StyledTableCell,
  StyledTableRow,
} from '../helpers/module.styled';

const Header = [
  [
    {
      text: '#',
      style: { ...style1, minWidth: '140px' },
    },

    {
      text: 'MRR NO.',
      style: { ...style1, minWidth: '140px' },
    },
    {
      text: 'MRR Date',
      style: { ...style1, minWidth: '140px' },
    },
    {
      text: 'Supplier',
      style: { ...style1, minWidth: '140px' },
    },
    {
      text: 'Reference  No.',
      style: { ...style1, minWidth: '140px' },
    },

    {
      text: 'ACTION',
      style: { ...style1, minWidth: '140px' },
    },
  ],
];

const List = () => {
  const date = useQuery('date');
  const [tableData, setTableData] = useState<any[]>([]);
  const [render, setRender] = useState(false);
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const navigate = useNavigate();
  const [DialogDelete, confirmDelete] = useConfirm(
    'DELETE',
    'Are you sure you want to delete this document?'
  );

  useEffect(() => {
    axios
      .get(`${constants.api.crud}/monthly/${date}`)
      .then((res) => {
        if (res.data) setTableData(res.data);
      })
      .catch((err) => console.log(err));
  }, [render, date]);

  // const deleteDocument = async (id: string) => {
  //   const ans = await confirmDelete();
  //   if (!ans) return;
  //   axios
  //     .delete(`${constants.api.crud}/${id}`)
  //     .then(() => {
  //       alert('document deleted successfully');
  //       setRender((prev) => !prev);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   return;
  // };

  return (
    <>
      <ChildHeader text={`${constants.moduleName}`}>
        <AddButton
          onClick={() => setIsOpenPopup(true)}
          label={`${constants.btnLabel}`}
        />
      </ChildHeader>
      <Box sx={{ margin: 2 }}>
        <PersitedDatePicker label="Search By Month" views={['month', 'year']} />
      </Box>

      <TableCustom tableHeaderObj={Header}>
        <TableBody>
          {tableData.map(
            (document: { [key: string]: any }, documentIndex: number) => (
              <StyledTableRow index={documentIndex}>
                <StyledTableCell align="center">
                  {documentIndex + 1}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {document?.mrr_no}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {formatDate(document?.mrr_date)}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {document?.supplier_id?.vender_name}
                </StyledTableCell>
                <StyledTableCell align="center">
                  {document?.ref_no}
                </StyledTableCell>
                <StyledTableCell align="center">
                  <ViewIconButton
                    tooltipTitle="view"
                    onClick={() =>
                      navigate(
                        `${constants.navigate.view}/${document.supplier_id?._id}/${document._id}?isView=true`
                      )
                    }
                  />
                  <EditIconButton
                    tooltipTitle="edit"
                    onClick={() =>
                      navigate(
                        `${constants.navigate.view}/${document.supplier_id?._id}/${document._id}?isView=false`
                      )
                    }
                  />
                  {/*<DeleteIconButton
                    tooltipTitle="delete"
                    onClick={() => deleteDocument(document._id)}
                  />*/}
                </StyledTableCell>
              </StyledTableRow>
            )
          )}
        </TableBody>
      </TableCustom>
      <ModalCustom
        title="SUPPLIER LIST"
        openModal={isOpenPopup}
        closeModal={() => {
          setIsOpenPopup(false);
        }}
      >
        <SelectSupplier />
      </ModalCustom>

      <DialogDelete isSubmitContent={false} />
    </>
  );
};

export default List;
